import { render, staticRenderFns } from "./error410.vue?vue&type=template&id=099368c6"
import script from "./error410.vue?vue&type=script&lang=js"
export * from "./error410.vue?vue&type=script&lang=js"
import style0 from "./error410.vue?vue&type=style&index=0&id=099368c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports